import React, { PureComponent, Component } from 'react';
import {
    BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend,
    LineChart, Line,
    PieChart, Pie, Sector, ResponsiveContainer
} from 'recharts';
import { connect } from 'react-redux';
import '../Home.css'
import DateRangePicker from 'react-bootstrap-daterangepicker';
import { bindActionCreators } from 'redux'
import moment from "moment";
import ComboboxInput from "../PushInteractive/ComboboxInputCustom";
import { fromJS } from "immutable";
import { ClientId, PrevilageId, SenderId } from "../../helper/HelperAuth";
import ActionGetAllSender from "../../store/action/Sender/FetchAll";
import ActionGetPushSummary from "../../store/action/Home/PushSummaryFetch"
import ActionGetDailyMessageByStatus from "../../store/action/PushSummary/DailyMessageByStatus"
import ActionGetReadRateByDay from "../../store/action/PushSummary/ReadRateByDay"
import ActionGetReadRateByTime from "../../store/action/PushSummary/ReadRateByTime"
import ActionGetPushFormatDistribution from "../../store/action/PushSummary/PushFormatDistribution"
import { toast } from "react-toastify";
import ActionFetchTemplate from "../../store/action/TemplateHsm/Fetch";
import ActionFetchBatchName from "../../store/action/BatchName/Fetch";
import ActionHighestReadRate from "../../store/action/PushSummary/HighesReadRate"
import ActionGetAccessModule from "../../store/action/AccessModule/Fetch";
import ActionGetClient from '../../store/action/Client/FetchAll'
import ActionFindByGroupId from '../../store/action/Previlage/FindByGroupId'

const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#F933FF", "#ff0000", "#87ceeb"];
const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
        if (payload[0].payload["name"] == "image" && payload[0].payload["extension"] == 0) {
            return (
                <div>
                    <p className="labels" style={{ color: "black" }}>Image : 0</p>
                </div>
            )
        } else if (payload[0].payload["name"] == "text" && payload[0].payload["extension"] == 0) {
            return (
                <div>
                    <p className="labels" style={{ color: "black" }}>Text : 0</p>
                </div>
            );
        } else if (payload[0].payload["name"] == "video" && payload[0].payload["extension"] == 0) {
            return (
                <div>
                    <p className="labels" style={{ color: "black" }}>Video : 0</p>
                </div>
            );
        } else if (payload[0].payload["name"] == "document" && payload[0].payload["extension"] == 0) {
            return (
                <div>
                    <p className="labels" style={{ color: "black" }}>Document : 0</p>
                </div>
            );
        } else if (payload[0].payload["name"] == "undefined" && payload[0].payload["extension"] == 0) {
            return (
                <div>
                    <p className="labels" style={{ color: "black" }}>Undefined : 0</p>
                </div>
            );
        } else if (payload[0].payload["name"] == "button" && payload[0].payload["extension"] == 0) {
            return (
                <div>
                    <p className="labels" style={{ color: "black" }}>Button : 0</p>
                </div>
            );
        } else {
            return (
                <div>
                    <p className="labels" style={{ color: "black" }}>{payload[0].payload["name"]} : {payload[0].payload["value"]}</p>
                </div>
            );
        }
    }
    return null;
};
class Page extends Component {
    constructor(props) {
        super(props)
        this.state = {
            title: "Push Dashboard",
            isadmin:false,
            dates: moment().format('D MMMM YYYY') + " - " + moment().format('D MMMM YYYY'),
            form: fromJS({
                'client': ClientId,
                'sender': SenderId,
                'tahun': "",
                'bulan': "",
                'tanggal-mulai': "",
                'tanggal-selesai': "",
                "template-name": "",
                "batch-name": ""
            }),
            hidecliet: 'hide',
            initstart: moment().format('MM/D/YYYY').toString(),
            initend: moment().format('MM/D/YYYY').toString(),
            startDate: '',
            endDate: '',
            intertotick: 0,
            interinquiry: 0,
            interaverage: 0,
            tooltip: "",
            dissender: true,
            errors: fromJS({}),
            dataDailyMessageByStatus: [],
            dataReadRateByDay: [],
            dataReadRateByTime: [],
            dataPushFormat: [],
            dataHighestReadRate: '',
            loaderStyle: {},
            actionid: '',
            colhide: '"forms-groups cols-sm-6"'

        };

        this.handleChange = this.handleChange.bind(this)
        this.handleCallback = this.handleCallback.bind(this)
        this.handleref = this.handleref.bind(this)
        this.handlebody = this.handlebody.bind(this)
    }

    handleActionId() {
        let array = []
        let action = 0;
        let menuPrev = (this.props.accessmodules.get('data') != null ? this.props.accessmodules.get('data') : fromJS([]));
        {
            menuPrev.map((data, i) =>
                array.push({
                    'menu-name': data.get('menu-name'),
                    'action-id': data.get('action-id')
                })

            )
        }

        for (let i = 0; i < array.length; i++) {
            if (array[i]['menu-name'] === 'Push Summary') {
                action = array[i]['action-id'];
                this.state.action_id = array[i]['action-id'];
            }
        }
        return action;
    }

    async handleChange(field, value, label) {
        var formVal = this.state.form;
        let newDate = new Date()

        let startDate = newDate.getDate();
        let endDate = newDate.getDate();
        let month = newDate.getMonth() + 1;
        let year = newDate.getFullYear();

        if (formVal.get('tahun') !== '') {
            year = formVal.get('tahun')
        }

        if (formVal.get('bulan') !== '') {
            month = formVal.get('bulan')
        }

        if (formVal.get('tanggal-mulai') !== '') {
            startDate = formVal.get('tanggal-mulai')
        }

        if (formVal.get('tanggal-selesai') !== '') {
            endDate = formVal.get('tanggal-selesai')
        }

        if (value == null) {
            value = "";
        }
        if (field == 'client') {
        	if (value == '') {
                this.props.actionGetAllSender(ClientId)
                this.props.actionFetchTemplate(ClientId)
            } else {
                this.props.actionGetAllSender(value)
                this.props.actionFetchTemplate(value)
            }
           

            formVal = formVal.set('sender', '')
        }
        if (field == 'sender') {
            if (value == "") {
                toast.warn('Sender cannot be empty');
                return false
            }
            if (this.state.actionid == 5) {
                if (PrevilageId == 1 || this.state.isadmin == true) this.props.actionFetchTemplate(formVal.get('client'), value, 5);
                else this.props.actionFetchTemplate(ClientId, value, 5)
            } else {
                if (PrevilageId == 1 || this.state.isadmin == true) this.props.actionFetchTemplate(formVal.get('client'), value);
                else this.props.actionFetchTemplate(ClientId, value)
            }
        }

        if (field == 'template-name') {
            this.props.actionFetchBatchName(formVal.get('sender'), value)
            formVal = formVal.set("batch-name", "");
        }
        formVal = formVal.set(field, value);
        //debugger
        this.setState({ form: formVal })
        if (formVal.get('sender') == "") {
            toast.warn('Sender cannot be empty');
        } else {
            var body = {
                "sender": formVal.get('sender'),
                "tahun": year.toString(),
                "bulan": month.toString(),
                "tanggal-mulai": startDate.toString(),
                "tanggal-selesai": endDate.toString(),
                "templatename": formVal.get("template-name"),
                "batchname": formVal.get("batch-name")
            }
            this.setState({ loaderStyle: {} })
            this.props.actionGetPushSummary(body)
            this.props.actionHighestReadRate(body)
            var dataDaily = await this.props.actionGetDailyMessageByStatus(body)
            var dataReadByDay = await this.props.actionGetReadRateByDay(body)
            var dataReadByTime = await this.props.actionGetReadRateByTime(body)
            var dataPush = await this.props.actionGetPushFormatDistribution(body)
            this.setState({
                dataDailyMessageByStatus: dataDaily,
                dataReadRateByDay: dataReadByDay,
                dataReadRateByTime: dataReadByTime,
                dataPushFormat: dataPush,
                loaderStyle: { display: 'none' }
            })
        }
    }

    async handleref(start, end) {
        await this.handlebody(start, end)
    }

    async handlebody(start, end) {
        var formVal = this.state.form
        const { form } = this.state
        var arraystart = start.split("/")
        var arrayend = end.split("/")
        var bulan = arraystart[0]
        var tahun = arraystart[2]
        var tglstart = arraystart[1]
        var tglend = arrayend[1]
        var bulanEnd = arrayend[0]

        if (bulan != bulanEnd) {
            toast.warn('Start and end dates must be in the same period (month, year)');
            return
        }

        if (bulan[0] == "0") bulan = bulan[1]

        if (tglstart[0] == "0") tglstart = tglstart[0]

        if (tglend[0] == "0") tglend = tglend[0]
        
        formVal = formVal.set("tahun", tahun)
            .set("bulan", bulan)
            .set("tanggal-mulai", tglstart)
            .set("tanggal-selesai", tglend)

        this.setState({ form: formVal })

        var body = {
            "sender": formVal.get('sender'),
            "tahun": tahun.toString(),
            "bulan": bulan.toString(),
            "tanggal-mulai": tglstart.toString(),
            "tanggal-selesai": tglend.toString(),
            "templatename": formVal.get("template-name"),
            "batchname": formVal.get("batch-name")
        }


        this.props.actionGetPushSummary(body)
        this.props.actionHighestReadRate(body)
        var dataDaily = await this.props.actionGetDailyMessageByStatus(body)
        var dataReadByDay = await this.props.actionGetReadRateByDay(body)
        var dataReadByTime = await this.props.actionGetReadRateByTime(body)
        var dataPush = await this.props.actionGetPushFormatDistribution(body)
        this.setState({
            dataDailyMessageByStatus: dataDaily,
            dataReadRateByDay: dataReadByDay,
            dataReadRateByTime: dataReadByTime,
            dataPushFormat: dataPush,
            loaderStyle: { display: 'none' }
        })
    }

    handleCallback(start, end, label) {
        var starts = start.format('MM/D/YYYY').toString()
        var ends = end.format('MM/D/YYYY').toString()
        var dated = start.format('D MMMM YYYY') +
            " - " + end.format('D MMMM YYYY')
        this.handleref(starts, ends)
        this.setState({ dates: dated })
    }

    async componentDidMount() {
        var isAdmin = await this.props.actionFindByGroupId()
        this.setState({isadmin:isAdmin})

        if (PrevilageId > 1 && isAdmin == false) {
            this.setState({ hideclient: 'hide', colhide: 'forms-groups cols-sm-6' })
        } else {
            this.setState({ hideclient: '', colhide: 'forms-groups cols-sm-4' })
        }
        this.props.actionGetClient();
        this.props.actionGetAllSender(ClientId)
        await this.props.actionGetAccessModule(PrevilageId);
        let restrict = this.handleActionId()
        let dissen = this.state.dissender
        if (restrict == 5) {
            this.props.actionFetchTemplate(ClientId, SenderId, 5);
            dissen = true

        }
        else dissen = false
        this.props.actionFetchTemplate(ClientId, SenderId);
        this.handleref(this.state.initstart, this.state.initend)
        this.setState({ dissender: dissen, actionid: restrict })
    }

    render() {
        const { title, loaderStyle } = this.state;
        const { form, searchForm, errors } = this.state;
        let pushSummaryData = this.props.homepushsummary
        let dataGetHighestRateRead = this.props.gethighestreadrate
        let dailyMessageByStatus = this.props.getdailymessagebystatus
        return (
            <div>
                <div className="page-loader-wrapper" style={loaderStyle}>
                    <div className="loader">
                        <div className="preloader">
                            <div className="spinner-layer pl-orange">
                                <div className="circle-clipper left">
                                    <div className="circle"></div>
                                </div>
                                <div className="circle-clipper right">
                                    <div className="circle"></div>
                                </div>
                            </div>
                        </div>
                        <p>Please wait...</p>
                    </div>
                </div>
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="rows mb-2">
                            <div className="cols-sm-2">
                                <h1 className="m-0 titles-card-head">Push Dashboard</h1>
                            </div>
                        </div>
                        <div className="rows mb-2">
                            <div className={this.state.colhide}>
                                <DateRangePicker
                                    initialSettings={{
                                        startDate: moment().format('MM/D/YYYY').toString(),
                                        endDate: moment().format('MM/D/YYYY').toString(),
                                        ranges: {
                                            Today: [moment().toDate(), moment().toDate()],
                                            Yesterday: [
                                                moment().subtract(1, 'days').toDate(),
                                                moment().subtract(1, 'days').toDate(),
                                            ],
                                            'Last 7 Days': [
                                                moment().subtract(6, 'days').toDate(),
                                                moment().toDate(),
                                            ],
                                            'Last 30 Days': [
                                                moment().subtract(29, 'days').toDate(),
                                                moment().toDate(),
                                            ],
                                            'This Month': [
                                                moment().startOf('month').toDate(),
                                                moment().endOf('month').toDate(),
                                            ],
                                            'Last Month': [
                                                moment().subtract(1, 'month').startOf('month').toDate(),
                                                moment().subtract(1, 'month').endOf('month').toDate(),
                                            ],
                                        }
                                    }}
                                    onCallback={this.handleCallback}
                                >
                                    <div class="cols-sm-12 floats-right calendar">
                                        <i class="fa fa-calendar"></i>&nbsp;&nbsp;
                                        <span>{this.state.dates}</span> <i class="fa fa-caret-down"></i>
                                    </div>
                                </DateRangePicker>

                            </div>
                            <div className={`forms-groups cols-sm-2 right ${this.state.hideclient}`}>
                                <ComboboxInput
                                    field='client'
                                    value={form.get('client')}
                                    options={fromJS({
                                        'source': this.props.clientall,
                                        'value': 'client-id',
                                        'label': 'client-name'
                                    })}
                                    onChange={(field, value, label) => this.handleChange(field, value, label)}
                                    placeholder="Client"
                                    disabled={this.state.dissender}
                                />
                            </div>
                            <div className="forms-groups cols-sm-2 floats-right">
                                <ComboboxInput
                                    field='sender'
                                    value={form.get('sender')}
                                    options={fromJS({
                                        'source': this.props.senderall,
                                        'value': 'sender-id',
                                        'label': 'sender-id-name'
                                    })}
                                    onChange={(field, value, label) => this.handleChange(field, value, label)}
                                    placeholder="Sender"
                                    disabled={this.state.dissender}
                                    hasError={errors.has('sender')}
                                />
                            </div>
                            <div className="forms-groups cols-sm-2 floats-right">
                                <ComboboxInput
                                    field='template-name'
                                    value={form.get('template-name')}
                                    options={fromJS({
                                        'source': this.props.templates,
                                        'value': 'template-name',
                                        'label': 'template-name'
                                    })}
                                    onChange={(field, value, label) => this.handleChange(field, value, label)}
                                    placeholder="Template"
                                    disabled={this.state.dissender}
                                    hasError={errors.has('template-name')}
                                />
                            </div>
                            <div className="forms-groups cols-sm-2 floats-right">
                                <ComboboxInput
                                    field='batch-name'
                                    value={form.get('batch-name')}
                                    options={fromJS({
                                        'source': this.props.getbacthname,
                                        'value': 'batchname',
                                        'label': 'batchname'
                                    })}
                                    onChange={(field, value, label) => this.handleChange(field, value, label)}
                                    placeholder="Batch Name"
                                    disabled={this.state.dissender}
                                    hasError={errors.has('bacth-name')}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="content">
                    <div className="container-fluid">
                        <div className="rows">
                            <div className="cols-lg-12">
                                <div className="content-header">
                                    <div className="rows mb-2">
                                        <div className="cols-sm-12">
                                            <h1 className="m-0 titles-card-child">Push Summary</h1>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xs-2" id="p1">
                                        <div className="small-box blue">
                                            <div className="inner">
                                                <h3>{pushSummaryData.get('total')}</h3>
                                                <p className='titles-card-child2'>Total Messages</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xs-2 " id="p2">
                                        <div className="small-box red">
                                            <div className="inner">
                                                <h3>{pushSummaryData.get('total-sent')}</h3>
                                                <p className='titles-card-child2'>Total Sent Messages</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xs-2 " id="p3">
                                        <div className="small-box orange">
                                            <div className="inner">
                                                <h3>{pushSummaryData.get('total-delivered')}</h3>
                                                <p className='titles-card-child2'>Total Delivered Messages</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xs-2 " id="p4">
                                        <div className="small-box yellow">
                                            <div className="inner">
                                                <h3>{pushSummaryData.get('total-read')}</h3>
                                                <p className='titles-card-child2'>Total Read Messages</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xs-2 " id="p5">
                                        <div className="small-box grey">
                                            <div className="inner">
                                                <h3>{pushSummaryData.get('total-failed')}</h3>
                                                <p className='titles-card-child2'>Total Failed Messages</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="content">
                    <div className="container-fluid">
                        <div className="rows">
                            <div className="cols-lg-12">
                                <div className="content">
                                    <div className="rows">
                                        <div className="cols-lg-12">
                                            <div className="cards">
                                                <div className="cards-header border-0">
                                                    <div className="d-flex justify-content-between">
                                                        <h3 className="cards-title">Daily Message By Status</h3>
                                                    </div>
                                                </div>
                                                <div className="cards-body">
                                                    <ResponsiveContainer width='100%' height={350}>
                                                        <BarChart
                                                            height={300}
                                                            data={this.state.dataDailyMessageByStatus}
                                                            margin={{
                                                                top: 5,
                                                                right: 30,
                                                                left: 20,
                                                                bottom: 5
                                                            }}
                                                        >
                                                            <CartesianGrid strokeDasharray="3 3" />
                                                            <XAxis dataKey="name" />
                                                            <YAxis />
                                                            <Tooltip />
                                                            <Legend />
                                                            <Bar dataKey="Sent" fill="#ff4d4d" />
                                                            <Bar dataKey="Delivered" fill="#FF6C20" />
                                                            <Bar dataKey="Read" fill="#F9B03C" />
                                                            <Bar dataKey="Failed" fill="#B3B6BD" />
                                                        </BarChart>
                                                    </ResponsiveContainer>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="content">
                    <div className="container-fluid">
                        <div className="rows">
                            <div className="cols-lg-12">
                                <div className="content">
                                    <div className="rows">
                                        <div className="cols-lg-6">
                                            <div className="cards">
                                                <div className="cards-header border-0">
                                                    <div className="d-flex justify-content-between">
                                                        <h3 className="cards-title">Read Rate by Day</h3>
                                                    </div>
                                                </div>
                                                <div className="cards-body">
                                                    <ResponsiveContainer width='100%' height={350}>
                                                        <BarChart
                                                            height={350}
                                                            data={this.state.dataReadRateByDay}
                                                            margin={{
                                                                top: 5,
                                                                right: 30,
                                                                left: 20,
                                                                bottom: 5
                                                            }}
                                                        >
                                                            <CartesianGrid strokeDasharray="3 3" />
                                                            <XAxis dataKey="name" />
                                                            <YAxis />
                                                            <Tooltip />
                                                            <Legend />
                                                            <Bar dataKey="read" fill="#FF6C20" />
                                                        </BarChart>
                                                    </ResponsiveContainer>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="cols-lg-6">
                                            <div className="cards">
                                                <div className="cards-header border-0">
                                                    <div className="d-flex justify-content-between">
                                                        <h3 className="cards-title">Read Rate by Time</h3>
                                                    </div>
                                                </div>
                                                <div className="cards-body">
                                                    <ResponsiveContainer width='100%' height={350}>
                                                        <LineChart
                                                            height={350}
                                                            data={this.state.dataReadRateByTime}
                                                            margin={{
                                                                top: 5,
                                                                right: 30,
                                                                left: 20,
                                                                bottom: 5
                                                            }}
                                                        >
                                                            <CartesianGrid strokeDasharray="3 3" />
                                                            <XAxis dataKey="name" />
                                                            <YAxis />
                                                            <Tooltip />
                                                            <Legend />
                                                            <Line
                                                                type="monotone"
                                                                dataKey="read"
                                                                stroke="#FF6C20"
                                                                activeDot={{ r: 8 }}
                                                            />
                                                        </LineChart>
                                                    </ResponsiveContainer>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div className="content">
                    <div className="container-fluid">
                        <div className="rows">
                            <div className="cols-lg-12">
                                <div className="content">
                                    <div className="rows">
                                        <div className="cols-lg-6">
                                            <div className="cards">
                                                <div className="cards-header border-0">
                                                    <div className="d-flex justify-content-between">
                                                        <h3 className="cards-title">Push Format Distribution</h3>
                                                    </div>
                                                </div>
                                                <div className="cards-body">
                                                    <ResponsiveContainer width='100%' height={350}>
                                                        <PieChart height={240}>
                                                            <Pie
                                                                data={this.state.dataPushFormat}
                                                                dataKey="value"
                                                                innerRadius={50}
                                                                outerRadius={100}
                                                                margin={{
                                                                    top: 20, right: 10, left: -20, bottom: 10,
                                                                }}
                                                            >
                                                                {this.state.dataPushFormat.map((entry, index) => (
                                                                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                                                ))}
                                                            </Pie>
                                                            <Tooltip content={<CustomTooltip />} />
                                                            <Legend
                                                                layout="vertical"
                                                                align="right"
                                                                verticalAlign="middle" />
                                                        </PieChart>
                                                    </ResponsiveContainer>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="cols-lg-6">
                                            <div className="cards">
                                                <div className="cards-header border-0">
                                                    <div className="d-flex justify-content-between">
                                                    </div>
                                                </div>
                                                <div className="cards-body ">
                                                    <div className="col-sm-12" id="p3">
                                                        <div className="very-large-box orange">
                                                            <div className="inner">
                                                                <h1>Highest Read Rates</h1>
                                                                <h3>Day : {dataGetHighestRateRead.get('nama-hari')}, Hour : {dataGetHighestRateRead.get('jam')}.00 </h3>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    (state) => {
        return {
            isLoggedIn: state.auth.isLoggedIn,
            senderall: state.user.senders,
            homepushsummary: state.user.homepushsummary,
            getdailymessagebystatus: state.user.getdailymessagebystatus,
            getreadratebyday: state.user.getreadratebyday,
            getpushformatdistribution: state.user.getpushformatdistribution,
            templates: state.user.templateall,
            getbacthname: state.user.getbacthname,
            gethighestreadrate: state.user.gethighestreadrate,
            accessmodules: state.user.accessmodules,
            clientall: state.user.clientall
        }
    },
    dispatch => bindActionCreators({
        actionGetAccessModule: ActionGetAccessModule,
        actionGetAllSender: ActionGetAllSender,
        actionGetPushSummary: ActionGetPushSummary,
        actionGetDailyMessageByStatus: ActionGetDailyMessageByStatus,
        actionGetReadRateByDay: ActionGetReadRateByDay,
        actionGetReadRateByTime: ActionGetReadRateByTime,
        actionGetPushFormatDistribution: ActionGetPushFormatDistribution,
        actionFetchTemplate: ActionFetchTemplate,
        actionFetchBatchName: ActionFetchBatchName,
        actionHighestReadRate: ActionHighestReadRate,
        actionGetClient: ActionGetClient,
        actionFindByGroupId:ActionFindByGroupId
    }, dispatch),
)(Page);